enum RouteType {
  GUEST = 'GUEST',
  PRIVATE = 'PRIVATE',
}

export default RouteType;
